<template>
  <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g v-show="up" opacity="0.5">
      <path d="M4.99779 3.58332C5.08946 3.58332 5.1728 3.61666 5.23946 3.68333L7.3228 5.84999C7.4478 5.98333 7.4478 6.19166 7.31446 6.32499C7.18113 6.44999 6.97279 6.44999 6.83946 6.31666L4.99779 4.39999L3.15612 6.31666C3.03112 6.44999 2.81445 6.44999 2.68112 6.32499C2.54779 6.19999 2.5478 5.98333 2.6728 5.84999L4.75612 3.68333C4.82279 3.61666 4.90613 3.58332 4.99779 3.58332Z" :fill="fill"/>
    </g>
    <g v-show="down" opacity="0.5">
      <path d="M5.00221 13.4167C4.91054 13.4167 4.82721 13.3833 4.76054 13.3167L2.6772 11.15C2.5522 11.0167 2.5522 10.8083 2.68554 10.675C2.81887 10.55 3.02721 10.55 3.16054 10.6833L5.00221 12.6L6.84388 10.6833C6.96888 10.55 7.18555 10.55 7.31888 10.675C7.45221 10.8 7.4522 11.0167 7.3272 11.15L5.24388 13.3167C5.17721 13.3833 5.09387 13.4167 5.00221 13.4167Z" :fill="fill"/>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'filterIcon',
    props: {
      fill: {
        type: String,
        default: '#00527F'
      },
      up: {
        type: Boolean,
        required: false,
        default: true
      },
      down: {
        type: Boolean,
        required: false,
        default: true
      }
    }
  }
</script>
